import { useCallback } from "react";
import "./Advertisement.scss";
import { theme, Divider, notification } from "antd";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { SocialLinks, Billboard } from "./components";

export default function Advertisement() {
  const { useToken } = theme;
  const { token } = useToken();
  const { isMobile } = useWindowDimensions();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (type, title, text) => {
      api[type]({
        message: title,
        description: text,
        placement: "top",
      });
    },
    [api]
  );

  return (
    <>
      {contextHolder}
      <div className="advertisement-cont">
        {!isMobile ? (
          <Divider
            className="advertisement-cont__divider"
            type="vertical"
            style={{ margin: "0px" }}
          />
        ) : null}

        <div className="advertisement-cont__adsWraper">
          <Billboard
            token={token}
            openNotificationWithIcon={openNotificationWithIcon}
          />

          <SocialLinks token={token} />
          {isMobile ? <div className="advertisement-cont__separator" /> : null}
        </div>
      </div>
    </>
  );
}
